import { recordSentry } from "./recordSentry";
import { FormTemplate } from "db/definitions";
// @ts-ignore
import { batchGetFormTemplates } from "graphql/queries";
import { generateClient, GraphQLResult } from "aws-amplify/api";
import { handleBatchCrud } from "./handleBatchCrud";

/**
 * handles batch retrieval of form templates
 * @param {array} ids the form templates to be retrieved from the db
 * @returns true or an error
 */
export default async function handleBatchGetFormTemplates(ids: string[]) {
	try {
		const formTemplates = await handleBatchCrud(ids, batchRetrieveFormTemplates, 100);
		return formTemplates;
	} catch (err) {
		recordSentry({ error: err, msg: "Error handling batch get form templates: " });
	}
	return [];
}

async function batchRetrieveFormTemplates(ids: string[]): Promise<FormTemplate[]> {
	interface QueryResponse {
		batchGetFormTemplates: FormTemplate[];
	}
	const client = generateClient({ authMode: "userPool" });
	const result = (await client.graphql({
		query: batchGetFormTemplates,
		variables: { ids },
		authMode: "userPool",
	})) as GraphQLResult<QueryResponse>;
	return result.data.batchGetFormTemplates;
}
